export default __webpack_public_path__ + "resources/icons/foreca-b001.svg";